import { gql } from "apollo-boost";

export const GET_COURSEOUTLINEUNIT = gql`
  query getCourseOutlineUnit($id: ID!) {
    getCourseOutlineUnit(
      id: $id
    ) {
      id
      seq nameLocal nameEng descriptionLocal descriptionEng
      preTestExpectScore postTestExpectScore
      unitAgenda unitObjective unitReference
      courseOutline { id }
    }
  }
`;
export const GET_COURSEOUTLINEUNIT_FOR_EXAM = gql`
  query getCourseOutlineUnitsForExam($subjectId: ID!, $teacherId: ID!) {
    getCourseOutlineUnitsForExam(
      subjectId: $subjectId
      teacherId: $teacherId
    ) {
      id
      seq nameLocal nameEng descriptionLocal descriptionEng
      preTestExpectScore postTestExpectScore
      unitAgenda unitObjective unitReference
      courseOutline { id }
    }
  }
`;

export const GET_COURSEOUTLINEUNITS = gql`
  query getCourseOutlineUnits {
    getCourseOutlineUnits {
      id
      seq nameLocal nameEng descriptionLocal descriptionEng
      preTestExpectScore postTestExpectScore
      unitAgenda unitObjective unitReference
      courseOutline { id }
    }
  }
`;

export const ADD_COURSEOUTLINEUNIT = gql`
  mutation addCourseOutlineUnit(
    $courseOutlineId: ID!,
    $courseOutlineUnitInput: CourseOutlineUnitInput!
  ) {
    addCourseOutlineUnit (
      courseOutlineId: $courseOutlineId,
      courseOutlineUnitInput: $courseOutlineUnitInput,
    ) {
      id
      seq nameLocal nameEng descriptionLocal descriptionEng
      preTestExpectScore postTestExpectScore
      unitAgenda unitObjective unitReference
      countLearnPercent
      mustLearnPrevious previousPercentRequireBeforeLearn
      courseOutline { id }
    }
  }
`;

export const UPDATE_COURSEOUTLINEUNIT = gql`
  mutation updateCourseOutlineUnit(
    $id: ID!,
    $courseOutlineUnitInput: CourseOutlineUnitInput!
  ) {
    updateCourseOutlineUnit (
      id: $id,
      courseOutlineUnitInput: $courseOutlineUnitInput
    ) {
      id
      seq nameLocal nameEng descriptionLocal descriptionEng
      preTestExpectScore postTestExpectScore
      unitAgenda unitObjective unitReference
      countLearnPercent
      mustLearnPrevious previousPercentRequireBeforeLearn
      courseOutline { id }
    }
  }
`;

export const DELETE_COURSEOUTLINEUNIT = gql`
  mutation deleteCourseOutlineUnit(
    $id: ID!
  ) {
    deleteCourseOutlineUnit (
      id: $id
    ) {
      id
      seq nameLocal nameEng descriptionLocal descriptionEng
      preTestExpectScore postTestExpectScore
      unitAgenda unitObjective unitReference
      countLearnPercent
      mustLearnPrevious previousPercentRequireBeforeLearn
      courseOutline { id }
    }
  }
`;


/* TYPES

type CourseOutlineUnit {
  id: ID!
  periodCode: String!
  year: String!
  semester: Int!
  isDisabled: Boolean!
  createdAt: String!
  updatedAt: String!
  createdBy: User
  updatedBy: User
}

*/
